import { render } from "./PortfolioView.vue?vue&type=template&id=49f15d57&scoped=true"
import script from "./PortfolioView.vue?vue&type=script&lang=js"
export * from "./PortfolioView.vue?vue&type=script&lang=js"

import "./PortfolioView.vue?vue&type=style&index=0&id=49f15d57&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f15d57"]])

export default __exports__